export const utfCharWithoutSpaceOnly = value => {
    let cleanValue = ''

    if (value) {
        cleanValue = value.replace(/[^\x20-\x7E]+/g, '').replace(/^\s+/, '')
    }
    return cleanValue
}

export const onlyNumsWithLength = (value, length) => {
    const cleanValue = value && value.replace(/[^\d]/g, '')

    return cleanValue && cleanValue.slice(0, length)
}

export const onlyPhoneNumber = value => {
    const cleanValue = value && value.replace(/[^\d|^\-+ /]/g, '')

    return cleanValue && cleanValue.slice(0, 16)
}
